import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApiContainer } from "../utils/api";
import { SET_API_DATA } from "../redux/constants";

const allReportsViewContainer = ({ userId, assessmentResult }) => {
  const { api } = ApiContainer();
  const dispatch = useDispatch();

  const result = useSelector((state) => state.api.viewAllReportResult);
  const currentAssessmentCardUserId = useSelector(
    (state) => state.api.currentAssessmentCardUserId
  );
  const [loading, setLoading] = useState(false);

  const fetchAllReports = async () => {
    setLoading(true);

    try {
      const fetchPromises = assessmentResult?.map(
        async ({ assessment_id, name }) => {
          try {
            const response = await api({
              method: "GET",
              endPoint: `assessment/users/${userId}/assessments/${assessment_id}/one-pager`,
              showToastMessage: false,
              urlencoded: false,
              needLoader: false,
              parent: "viewAllReportResult",
            });

            const data = response?.status
              ? response.data
              : { error: true, message: "No data found" };

            return {
              assessment_id,
              result: {
                data,
                assessment_id,
                assessment_name: name,
              },
            };
          } catch (error) {
            console.error(
              `Failed to fetch report for ID ${assessment_id}:`,
              error
            );
            return {
              assessment_id,
              result: {
                data: { error: true, message: "No data found" },
                assessment_id,
                assessment_name: name,
              },
            };
          }
        }
      );

      const responses = await Promise.all(fetchPromises);

      const resultMap = responses.reduce((acc, item) => {
        acc[item.assessment_id] = item.result;
        return acc;
      }, {});

      dispatch({
        type: SET_API_DATA,
        payload: {
          viewAllReportResult: resultMap,
          currentAssessmentCardUserId: userId,
        },
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (assessmentResult?.length && currentAssessmentCardUserId !== userId) {
      fetchAllReports();
    }
  }, [assessmentResult, userId]);

  return {
    result,
    loading,
  };
};

export default allReportsViewContainer;
